import type { MouseEvent } from 'react';

import { clickEventItems, TAB_ID } from '../constants';
import {
  trackCarhireTabClickedSmartMetric,
  trackFlightsTabClickedSmartMetric,
  trackHotelsTabClickedSmartMetric,
  trackPackagesTabClickedSmartMetric,
} from '../singleton/tracking/tracking';
import { clickEvents } from '../userTrackingEvents';

import type { NavigationTrackingComponent } from '../userTrackingEvents';
import type { Logger } from '@web-platform/global-components-types/utils';
import type { TrackingEventFn } from '@web-platform/global-components-utils/tracking';

const handleClickAndTrack = (
  e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  id: keyof typeof clickEventItems,
  eventType: string,
  logger: Logger,
  trackEventFn: TrackingEventFn,
  componentName: NavigationTrackingComponent = 'global_navigation',
) => {
  const item = clickEventItems[id] ? clickEventItems[id] : id;
  const headerClickEvents = clickEvents(item, eventType, componentName);
  trackEventFn(headerClickEvents);

  if (id === TAB_ID.FLIGHTS) {
    trackFlightsTabClickedSmartMetric();
  } else if (id === TAB_ID.HOTELS) {
    trackHotelsTabClickedSmartMetric();
  } else if (id === TAB_ID.CARHIRE) {
    trackCarhireTabClickedSmartMetric();
  } else if (id === TAB_ID.PACKAGES) {
    trackPackagesTabClickedSmartMetric();
  }

  logger.logOperationalEvent({
    eventName: `Header Item ${eventType}`,
    item,
  });
};

export default handleClickAndTrack;
